import React from 'react';
import { PlayCircle, ExternalLink } from 'lucide-react';
export function MediaSection() {
  return <section id="media" className="py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-112">
      <div className="max-w-7xl mx-auto" data-id="element-113">
        <div className="text-center mb-16" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-115">
            Media & Appearances
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full mb-6" data-id="element-116"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-117">
            Watch Arthur discuss the future of financial infrastructure,
            post-quantum security, and ethical innovation.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-12" data-id="element-118">
          {/* Podcast 1 */}
          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100 shadow-sm" data-id="element-119">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-slate-200 relative mb-4" data-id="element-120">
              <iframe src="https://www.youtube.com/embed/HP_rj8-P2AY" title="Arthur Miller Podcast Interview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-121"></iframe>
            </div>
            <h3 className="text-xl font-bold text-slate-900 px-2" data-id="element-122">
              Architecting Trust at Scale
            </h3>
            <p className="text-slate-600 px-2 mt-2" data-id="element-123">
              Deep dive into the foundational principles behind FiQIS and the
              future of banking.
            </p>
          </div>

          {/* Podcast 2 */}
          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100 shadow-sm" data-id="element-124">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-slate-200 relative mb-4" data-id="element-125">
              <iframe src="https://www.youtube.com/embed/6zZkMNVoEW8" title="Arthur Miller Podcast Interview 2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-126"></iframe>
            </div>
            <h3 className="text-xl font-bold text-slate-900 px-2" data-id="element-127">
              The Post-Quantum Banking Era
            </h3>
            <p className="text-slate-600 px-2 mt-2" data-id="element-128">
              Discussing the critical need for advanced encryption in modern
              financial systems.
            </p>
          </div>
        </div>

        {/* Fox 5 Feature */}
        <div className="bg-blue-900 rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden mb-16" data-id="element-129">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-800 rounded-full blur-3xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-130"></div>
          <div className="relative z-10" data-id="element-131">
            <span className="inline-block px-4 py-1 bg-blue-800 text-blue-100 text-sm font-bold tracking-wider uppercase rounded-full mb-6" data-id="element-132">
              Television Feature
            </span>
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-133">
              Fox 5 San Diego: Innovator's Journey
            </h3>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto mb-8" data-id="element-134">
              Watch the exclusive feature on how Arthur Miller's FiQIS is
              transforming finance and tackling the hidden costs of legacy
              banking infrastructure.
            </p>
            <a href="https://fox5sandiego.com/fox-5-partners/innovators-journey/arthur-millers-fiqis-is-transforming-finance/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-blue-900 font-bold rounded-lg hover:bg-blue-50 transition-colors" data-id="element-135">
              <PlayCircle className="h-5 w-5" data-id="element-136" />
              Watch Feature on Fox 5
            </a>
          </div>
        </div>

        {/* Additional Podcast Appearances */}
        <div className="mt-16" data-id="element-137">
          <div className="text-center mb-12" data-id="element-138">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-139">
              Additional Podcast Appearances
            </h3>
            <p className="text-slate-600" data-id="element-140">
              More conversations on fintech innovation, leadership, and the
              future of banking.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-141">
            <a href="https://youtube.com/watch?v=HP_rj8-P2AY" target="_blank" rel="noopener noreferrer" className="group bg-slate-50 rounded-xl p-6 border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all" data-id="element-142">
              <div className="flex items-start justify-between mb-3" data-id="element-143">
                <span className="text-sm font-bold text-blue-600 uppercase tracking-wider" data-id="element-144">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-blue-600 transition-colors" data-id="element-145" />
              </div>
              <h4 className="text-lg font-bold text-slate-900 group-hover:text-blue-700 transition-colors mb-2" data-id="element-146">
                Architecting Trust at Scale
              </h4>
              <p className="text-sm text-slate-600" data-id="element-147">
                Deep dive into the foundational principles behind FiQIS and the
                future of banking.
              </p>
            </a>

            <a href="https://youtube.com/watch?v=6zZkMNVoEW8" target="_blank" rel="noopener noreferrer" className="group bg-slate-50 rounded-xl p-6 border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all" data-id="element-148">
              <div className="flex items-start justify-between mb-3" data-id="element-149">
                <span className="text-sm font-bold text-blue-600 uppercase tracking-wider" data-id="element-150">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-blue-600 transition-colors" data-id="element-151" />
              </div>
              <h4 className="text-lg font-bold text-slate-900 group-hover:text-blue-700 transition-colors mb-2" data-id="element-152">
                The Post-Quantum Banking Era
              </h4>
              <p className="text-sm text-slate-600" data-id="element-153">
                Discussing the critical need for advanced encryption in modern
                financial systems.
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>;
}